<div class="section"
  [style.width]="formWidth"
  style="display: flex; flex-direction: column; height: fit-content; max-height: 800px;" data-cy="treatment-endo-edit-column-dialog-container">
  <div class="section-header" style="flex-basis: 30px;" data-cy="treatment-endo-edit-column-dialog-header">
    <div class="section-header-title" style="overflow: hidden;" data-cy="treatment-endo-edit-column-dialog-title">
      Tooth# {{getDocumentFormToothNumber()}} - {{title}}
    </div>
    @if (this.isenumEndoXWorkLength) {
      <div style="flex-basis: fit-content; cursor: pointer; margin-right: 15px; margin-top: 3px;" data-cy="treatment-endo-edit-column-dialog-filter-container"><mat-checkbox labelPosition="before" [checked]="this.isTreatmentEwlAwlFilter" (change)="onFilterByLenght($event)" data-cy="treatment-endo-edit-column-dialog-filter-checkbox">Increment by 0.50</mat-checkbox></div>
    }
  </div>
  @if (isLoading) {
    <app-tdo-progress-spinner style="flex: 1;" data-cy="treatment-endo-edit-column-dialog-progress-spinner"></app-tdo-progress-spinner>
  }
  @if (!isLoading) {
    <div class="section-content"
      style="display: flex; flex-direction: column; flex: 1; overflow-y: hidden;" data-cy="treatment-endo-edit-column-dialog-content">
      <div style="flex-basis: 50px; min-height: 50px; max-height: 50px; display: flex;" data-cy="treatment-endo-edit-column-dialog-dropdowns-container">
        <div style="flex-basis: 80px;" data-cy="treatment-endo-edit-column-dialog-canal-label">Canal</div>
        <div style="flex: 1; margin-left: 10px; margin-right: 10px;" data-cy="treatment-endo-edit-column-dialog-dropdown-1-container">
          <tdo-basic-dropdown [dataSet]="dropdownModels1"
            (itemSelected)="onDropdownSelect($event, columnPropertyNames[0])" [width]="'100%'" [height]="'40px'"
          [dropDownWidth]="'100%'" [dropDownHeight]="'250px'" data-cy="treatment-endo-edit-column-dialog-dropdown-1"></tdo-basic-dropdown>
        </div>
        @if (columnPropertyNames.length > 1) {
          <div style="flex: 1; margin-left: 10px; margin-right: 10px;" data-cy="treatment-endo-edit-column-dialog-dropdown-2-container">
            <tdo-basic-dropdown [dataSet]="dropdownModels2"
              (itemSelected)="onDropdownSelect($event, columnPropertyNames[1])" [width]="'100%'" [height]="'40px'"
            [dropDownWidth]="'100%'" [dropDownHeight]="'250px'" data-cy="treatment-endo-edit-column-dialog-dropdown-2"></tdo-basic-dropdown>
          </div>
          <div style="flex: 1; margin-left: 10px; margin-right: 10px;" data-cy="treatment-endo-edit-column-dialog-dropdown-3-container">
            <tdo-basic-dropdown [dataSet]="dropdownModels3"
              (itemSelected)="onDropdownSelect($event, columnPropertyNames[2])" [width]="'100%'" [height]="'40px'"
            [dropDownWidth]="'100%'" [dropDownHeight]="'250px'" data-cy="treatment-endo-edit-column-dialog-dropdown-3"></tdo-basic-dropdown>
          </div>
        }
      </div>
      <div style="flex: 1; overflow-y: auto;" data-cy="treatment-endo-edit-column-dialog-canal-list-container">
        @for (model of treatmentModel.dataTreatmentEndoCanals; track trackByCanal(canalIndex, model); let canalIndex = $index) {
          <div
            style="height: 100px; width: 100%; display: flex; margin-bottom: 8px;" class="canal-list-container" data-cy="treatment-endo-edit-column-dialog-canal-{{canalIndex}}">
            <div style="flex-basis: 80px; padding-left: 10px;" data-cy="treatment-endo-edit-column-dialog-canal-{{canalIndex}}-type-label">{{getModelCanalType(model)}}:</div>
            @for (col1 of columnPropertyNames; track trackByIndex(i, col1); let i = $index) {
              <div
                style="flex: 1; background-color: var(--tdo-background); margin-left: 10px; padding-left: 10px; border-radius: var(--border-radius); border: 1px solid rgba(0,0,0,0.05); overflow: auto;" data-cy="treatment-endo-edit-column-dialog-canal-{{canalIndex}}-column-{{i}}">
                @for (col of columnEnums[i]; track trackByEnum(itemIndex, col); let itemIndex = $index) {
                  <div class="list-item"
                    id="{{ 'selected-[' + i +']' + col.ValidValueItemId + '-' + model.TreatmentCanalID  }}"
                    [class.selected]="model[columnPropertyNames[i]] === col.ValidValueItemId"
                    (click)="onItemSelected(col.ValidValueItemId, model, columnPropertyNames[i])"
                    (contextmenu)="onRightMouseClick($event, columnEnums[i])"
                    (mousedown)="setUserTriggered(true)"data-cy="treatment-endo-edit-column-dialog-canal-{{canalIndex}}-column-{{i}}-item-{{itemIndex}}">
                    {{ col.ItemDisplayValue }}
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
    </div>
  }
  <div class="section-footer" style="flex-basis: 50px; min-height: 50px; padding-top: 4px;" data-cy="treatment-endo-edit-column-dialog-footer">
    <div style="flex: 1; margin-right: 6px;"></div>
    <button (click)="onOkClick()" class="tdo-button primary-accent" style="margin-right: 6px;" data-cy="treatment-endo-edit-column-dialog-ok-button">Ok</button>
    <button (click)="onCancelClick()" class="tdo-button primary-accent" style="margin-right: 6px;" data-cy="treatment-endo-edit-column-dialog-cancel-button">Cancel</button>
  </div>

  <ng-template #enumOptionsMenu let-data data-cy="treatment-endo-edit-column-dialog-enum-options-menu">
    <section style="border: 1px solid var(--tdo-secondary);" class="context-menu" data-cy="treatment-endo-edit-column-dialog-context-menu">
      <div (click)="onEditList()" class="item" style="color: black;" data-cy="treatment-endo-edit-column-dialog-edit-list-button">Edit List</div>
    </section>
  </ng-template>
</div>